import React from 'react';

interface CircleIconProps {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
}

/**
 * CircleIcon
 */
function CircleIcon({
  width,
  height,
  fill,
  stroke,
  strokeWidth = 2,
}: CircleIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 21 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <circle
        cx='10.5'
        cy='10'
        r='9'
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

CircleIcon.defaultProps = {
  width: 21,
  height: 20,
  fill: '#3751FF',
  stroke: '#D1D7FF',
  strokeWidth: 2,
};

export default CircleIcon;
